import { ShieldCheck } from 'lucide-react';

/**
 * "You own this app — no Alloterra review" callout, shared across the connect
 * guides. Reflects the bring-your-own-app model: each customer provisions their
 * OWN developer app that only ever touches their OWN accounts, so there is no
 * central/commercial App Review submitted on their behalf. For their own accounts
 * the platform's Standard/Development access covers it (a few platforms — e.g.
 * LinkedIn — ask the customer to verify their own app / enable a product, still a
 * step in their own dashboard).
 */
export function GuideByoaNote() {
  return (
    <div className="mt-4 flex gap-3 rounded-xl border border-success/20 dark:border-success-dark/30 bg-success-tint/70 dark:bg-success-dark-tint/70 px-4 py-3">
      <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-success dark:text-success-dark" aria-hidden />
      <div className="text-sm text-success/90 dark:text-success-dark">
        <p className="font-semibold text-success dark:text-success-dark">You own this app — no review on our side</p>
        <ul className="mt-1 list-disc space-y-1 pl-4">
          <li>
            You&apos;re creating <span className="font-semibold">your own</span> developer app that
            only ever accesses <span className="font-semibold">your own</span> accounts — so there&apos;s
            no central/commercial &ldquo;App Review&rdquo; for Smorgas Social to submit on your behalf.
          </li>
          <li>
            For your own accounts, permissions work at the platform&apos;s standard/development access.
            (A few platforms ask you to verify your own app or switch on a product first — a quick step
            in your own dashboard, still yours, not ours.)
          </li>
          <li>
            To let a teammate connect, add them to your app as a{' '}
            <span className="font-semibold">Tester</span> (or Admin).
          </li>
        </ul>
      </div>
    </div>
  );
}
